// extracted by mini-css-extract-plugin
module.exports = {"awardsContainer":"styles_awardsContainer__1wSZD","head":"styles_head__cDEdD","awards":"styles_awards__2i0iI","awardWrap":"styles_awardWrap__1FoW9"};